import { loadAssets } from '@meitu/saas-editor-core/es/utils/file-kit';
import { BrushPointType, MarkupPointType } from '@meitu/saas-editor-core/es/version-types';
import { getMaterialAssets } from '@/i18n/assets';

const darkAssets = loadAssets(import.meta.glob('@/assets/point/dark/*.svg', { eager: true }));
const lightAssets = loadAssets(import.meta.glob('@/assets/point/light/*.svg', { eager: true }));

/** 画笔端点类型配置 */
export function getBrushPointListMaterialConfig() {
    return {
        [BrushPointType.None]: { url: '', offset: 0, width: 0, height: 0 },
        [BrushPointType.StraightArrow]: {
            url: getMaterialAssets().brush.point.StraightArrow,
            offset: 4,
            width: 16.5,
            height: 30,
        },
        [BrushPointType.CurvedArrow]: {
            url: getMaterialAssets().brush.point.CurvedArrow,
            offset: 10,
            width: 21.4,
            height: 31,
        },
        [BrushPointType.HalfArrow]: {
            url: getMaterialAssets().brush.point.HalfArrow,
            offset: 3.2,
            width: 18,
            height: 37.8,
        },
        [BrushPointType.VerticalShape]: {
            url: getMaterialAssets().brush.point.VerticalShape,
            offset: 2,
            width: 4,
            height: 26.8,
        },
        [BrushPointType.SolidTriangle]: {
            url: getMaterialAssets().brush.point.SolidTriangle,
            offset: 7,
            width: 15,
            height: 21.1,
        },
        [BrushPointType.SolidCircle]: {
            url: getMaterialAssets().brush.point.SolidCircle,
            offset: 4,
            width: 16.5,
            height: 16.5,
        },
        [BrushPointType.HollowRect]: {
            url: getMaterialAssets().brush.point.HollowRect,
            offset: 25,
            width: 25.4,
            height: 25.4,
        },
    };
}

// 画笔端点类型列表
export const getBrushPointList = () => {
    return [
        {
            value: BrushPointType.None,
            light: lightAssets.get('None'),
            dark: darkAssets.get('None'),
            xdesign: lightAssets.get('None'),
            ...getBrushPointListMaterialConfig()[BrushPointType.None],
        },
        {
            value: BrushPointType.HollowRect,
            light: lightAssets.get('HollowRect'),
            dark: darkAssets.get('HollowRect'),
            xdesign: lightAssets.get('HollowRect'),
            ...getBrushPointListMaterialConfig()[BrushPointType.HollowRect],
        },
        {
            value: BrushPointType.VerticalShape,
            light: lightAssets.get('VerticalShape'),
            dark: darkAssets.get('VerticalShape'),
            xdesign: lightAssets.get('VerticalShape'),
            ...getBrushPointListMaterialConfig()[BrushPointType.VerticalShape],
        },

        {
            value: BrushPointType.StraightArrow,
            light: lightAssets.get('StraightArrow'),
            dark: darkAssets.get('StraightArrow'),
            xdesign: lightAssets.get('StraightArrow'),
            ...getBrushPointListMaterialConfig()[BrushPointType.StraightArrow],
        },
        {
            value: BrushPointType.CurvedArrow,
            light: lightAssets.get('CurvedArrow'),
            dark: darkAssets.get('CurvedArrow'),
            xdesign: lightAssets.get('CurvedArrow'),
            ...getBrushPointListMaterialConfig()[BrushPointType.CurvedArrow],
        },

        {
            value: BrushPointType.SolidTriangle,
            light: lightAssets.get('SolidTriangle'),
            dark: darkAssets.get('SolidTriangle'),
            xdesign: lightAssets.get('SolidTriangle'),
            ...getBrushPointListMaterialConfig()[BrushPointType.SolidTriangle],
        },
        {
            value: BrushPointType.SolidCircle,
            light: lightAssets.get('SolidCircle'),
            dark: darkAssets.get('SolidCircle'),
            xdesign: lightAssets.get('SolidCircle'),
            ...getBrushPointListMaterialConfig()[BrushPointType.SolidCircle],
        },
        {
            value: BrushPointType.HalfArrow,
            light: lightAssets.get('HalfArrow'),
            dark: darkAssets.get('HalfArrow'),
            xdesign: lightAssets.get('HalfArrow'),
            ...getBrushPointListMaterialConfig()[BrushPointType.HalfArrow],
        },
    ];
};

/** 标注笔端点类型配置 */
export function getMarkupPointListMaterialConfig() {
    return {
        [MarkupPointType.SharpTriangle]: {
            url: getMaterialAssets().markup.point.SharpTriangle,
            offset: 20,
            width: 28.789,
            height: 13,
        },
        [MarkupPointType.CurvedArrow]: {
            url: getMaterialAssets().markup.point.CurvedArrow,
            offset: 5.5,
            width: 13.493,
            height: 19.463,
        },
        [MarkupPointType.None]: { url: '', offset: 0, width: 0, height: 0 },
        [MarkupPointType.StraightArrow]: {
            url: getMaterialAssets().markup.point.StraightArrow,
            offset: 3.2,
            width: 11.212,
            height: 19,
        },
        [MarkupPointType.SolidTriangle]: {
            url: getMaterialAssets().markup.point.SolidTriangle,
            offset: 6,
            width: 9.952,
            height: 14,
        },
        [MarkupPointType.SolidCircle]: {
            url: getMaterialAssets().markup.point.SolidCircle,
            offset: 5,
            width: 10.313,
            height: 10.313,
        },
        [MarkupPointType.HollowRect]: {
            url: getMaterialAssets().markup.point.HollowRect,
            offset: 11,
            width: 13,
            height: 13,
        },
    };
}

// 标注笔端点类型列表
export const getMarkupPointList = () => {
    return [
        {
            value: MarkupPointType.None,
            light: lightAssets.get('None'),
            dark: darkAssets.get('None'),
            xdesign: lightAssets.get('None'),
            ...getMarkupPointListMaterialConfig()[MarkupPointType.None],
        },
        {
            value: MarkupPointType.HollowRect,
            light: lightAssets.get('HollowRect'),
            dark: darkAssets.get('HollowRect'),
            xdesign: lightAssets.get('HollowRect'),
            ...getMarkupPointListMaterialConfig()[MarkupPointType.HollowRect],
        },
        {
            value: MarkupPointType.StraightArrow,
            light: lightAssets.get('StraightArrow'),
            dark: darkAssets.get('StraightArrow'),
            xdesign: lightAssets.get('StraightArrow'),
            ...getMarkupPointListMaterialConfig()[MarkupPointType.StraightArrow],
        },
        {
            value: MarkupPointType.CurvedArrow,
            light: lightAssets.get('CurvedArrow'),
            dark: darkAssets.get('CurvedArrow'),
            xdesign: lightAssets.get('CurvedArrow'),
            ...getMarkupPointListMaterialConfig()[MarkupPointType.CurvedArrow],
        },
        {
            value: MarkupPointType.SolidTriangle,
            light: lightAssets.get('SolidTriangle'),
            dark: darkAssets.get('SolidTriangle'),
            xdesign: lightAssets.get('SolidTriangle'),
            ...getMarkupPointListMaterialConfig()[MarkupPointType.SolidTriangle],
        },
        {
            value: MarkupPointType.SolidCircle,
            light: lightAssets.get('SolidCircle'),
            dark: darkAssets.get('SolidCircle'),
            xdesign: lightAssets.get('SolidCircle'),
            ...getMarkupPointListMaterialConfig()[MarkupPointType.SolidCircle],
        },

        {
            value: MarkupPointType.SharpTriangle,
            light: lightAssets.get('SharpTriangle'),
            dark: darkAssets.get('SharpTriangle'),
            xdesign: lightAssets.get('SharpTriangle'),
            ...getMarkupPointListMaterialConfig()[MarkupPointType.SharpTriangle],
        },
    ];
};
